import { render, staticRenderFns } from "./EditResellerPaymentPage.vue?vue&type=template&id=4e290096"
import script from "./EditResellerPaymentPage.vue?vue&type=script&lang=js"
export * from "./EditResellerPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports